import { useEffect, useState } from 'react';
import {
  Typography,
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import { getAgendamentos, saveAgendamento } from '../services/api';

const AgendamentosPage = () => {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [titulo, setTitulo] = useState('');
  const [repetir, setRepetir] = useState(false);

  const load = () => {
    getAgendamentos().then(setRows).catch(console.error);
  };

  useEffect(() => {
    load();
  }, []);

  const handleSave = async () => {
    try {
      const novo = await saveAgendamento({
        titulo,
        data_inicio: selectedDate,
        repeticao: repetir,
      });
      setRows(prev => [...prev, novo]);
      setOpen(false);
      setTitulo('');
      setRepetir(false);
      setSelectedDate(new Date());
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5" fontWeight={900}>Agendamentos</Typography>
        <Button variant="contained" onClick={() => setOpen(true)}>Novo Agendamento</Button>
      </Stack>
      <TableContainer component={Paper} sx={{ mb: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Checklist</TableCell>
              <TableCell>Data início</TableCell>
              <TableCell>Repetição</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id} hover>
                <TableCell>{row.titulo}</TableCell>
                <TableCell>{row.data_inicio ? format(new Date(row.data_inicio), 'dd/MM/yyyy') : ''}</TableCell>
                <TableCell>{row.repeticao ? 'Sim' : 'Não'}</TableCell>
                <TableCell>
                  <span
                    style={{
                      padding: '4px 8px',
                      borderRadius: 4,
                      backgroundColor: row.status === 'CONCLUIDO' ? '#c8e6c9' : '#eee',
                      color: row.status === 'CONCLUIDO' ? '#2e7d32' : '#555',
                    }}
                  >
                    {row.status === 'CONCLUIDO' ? 'Concluído' : 'Pendente'}
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Novo Agendamento</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2} mt={1}>
            <TextField label="Checklist" fullWidth value={titulo} onChange={(e) => setTitulo(e.target.value)} />
            <DatePicker
              selected={selectedDate}
              onChange={(date) => date && setSelectedDate(date)}
              inline
            />
            <FormControlLabel
              control={<Checkbox checked={repetir} onChange={(e) => setRepetir(e.target.checked)} />}
              label="Repetir"
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="inherit">Cancelar</Button>
          <Button variant="contained" onClick={handleSave}>OK</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AgendamentosPage;
